import {
  ArchetypeAndStressLevel,
  CaseState,
  Feeling,
  stressLevelSchema,
} from '@/state/state.types';
import { getRandomInt } from './getRandomInt';

let cachedRandomArchetype: ArchetypeAndStressLevel | null = null;

export const mapCaseToArchetypeAndStressLevel = (
  caseState: CaseState | undefined,
): ArchetypeAndStressLevel => {
  if (!caseState)
    throw new Error('case state should be defined at mapCaseToArchetypeAndStressLevel');

  const fields = caseState.case.fields;

  const feelingResult = Feeling.safeParse(fields.feeling);
  const stressLevelResult = stressLevelSchema.safeParse(fields['stress-level']);

  if (!feelingResult.success || !stressLevelResult.success) {
    if (!cachedRandomArchetype) {
      const values = ArchetypeAndStressLevel.options;
      cachedRandomArchetype = values[getRandomInt(values.length)];
    }
    return cachedRandomArchetype;
  }

  const feeling = feelingResult.data;
  const stressLevel = stressLevelResult.data;

  switch (true) {
    case feeling === 'need-an-expert' && stressLevel < 3: {
      return ArchetypeAndStressLevel.Enum.delegator;
    }
    case feeling === 'need-an-expert' && stressLevel >= 3: {
      return ArchetypeAndStressLevel.Enum.delegator_stressed;
    }
    case feeling === 'wrong-and-unfair': {
      return ArchetypeAndStressLevel.Enum.crusader;
    }
    case feeling === 'overwhelmed': {
      return ArchetypeAndStressLevel.Enum.person_in_distress;
    }
    case feeling === 'researching-options' && stressLevel < 3: {
      return ArchetypeAndStressLevel.Enum.optimizer;
    }
    case feeling === 'researching-options' && stressLevel >= 3: {
      return ArchetypeAndStressLevel.Enum.optimizer_stressed;
    }
    case feeling === 'other' && stressLevel < 3: {
      return ArchetypeAndStressLevel.Enum.other;
    }
    case feeling === 'other' && stressLevel >= 3: {
      return ArchetypeAndStressLevel.Enum.other_stressed;
    }
    default: {
      throw new Error(
        `Can not define validation dependency for feeling: ${feeling} and stress level: ${stressLevel}`,
      );
    }
  }
};
